module.exports = __webpack_public_path__ + "static/img/img_zfb.f0dda390.jpg";